import { render } from "./PreRegRewardClaim.vue?vue&type=template&id=5cd93e90&scoped=true"
import script from "./PreRegRewardClaim.vue?vue&type=script&lang=js"
export * from "./PreRegRewardClaim.vue?vue&type=script&lang=js"

import "./PreRegRewardClaim.vue?vue&type=style&index=0&id=5cd93e90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd93e90"]])

export default __exports__